import ratmHash from "./RATMHash"

const HandleAddOrDropEditOrViewInTemplate = (role, key) => {

    const linkedFromHash = ratmHash.lookupHashTableItem(role.PortalRoleId, 2)

    let permissions = linkedFromHash[2].permissions
    let newLink = linkedFromHash
    if (permissions[`has${key}`] && !permissions[`drop${key}`]) {
        permissions[`drop${key}`] = true
    } else if (permissions[`has${key}`] && permissions[`drop${key}`]) {
        permissions[`drop${key}`] = false
    }
    if (!permissions[`has${key}`] && !permissions[`add${key}`]) {
        permissions[`add${key}`] = true
    } else if (!permissions[`has${key}`] && permissions[`add${key}`]) {
        permissions[`add${key}`] = false
    }
    ratmHash.updateHashTableItem(newLink, 2, true)
}

export default HandleAddOrDropEditOrViewInTemplate